import { Account } from '@/model';
import { Flex, Heading, Skeleton, Text } from '@chakra-ui/react';
import React from 'react';

export interface AccountDetailSectionHeaderProps {
  item: Account;
  isLoading: boolean;
}

const AccountDetailSectionHeaderComponent = ({ item, isLoading }: AccountDetailSectionHeaderProps) => {
  if (isLoading)
    return (
      <Flex flex={1} gap='kilo' justifyContent='space-between' align='center'>
        <Skeleton w='320px' h='deka' maxWidth='560px' />
        <Skeleton display={{ base: 'none', md: 'flex' }} w='120px' h='40px' maxWidth='560px' />
      </Flex>
    );

  return (
    <Flex flex={1} gap='kilo' justifyContent='space-between' align='center'>
      <Flex gap='kilo' align='center'>
        <Heading variant='sectionTitle'>
          <Text fontWeight='bold' as='span' color='brand.500'>
            {item.first_name?.toUpperCase()} {item.last_name?.toUpperCase()}
          </Text>
        </Heading>
        <Text fontWeight='normal' as='span'>
          ID: {item.card_number}
        </Text>
      </Flex>
    </Flex>
  );
};

export const AccountDetailSectionHeader = React.memo(AccountDetailSectionHeaderComponent);
